module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAA8klEQVRYhcXY6w3CMAxG0S9Vh2QAdgC6AJVYGgURFNI8/Ip7B4iOnD+Ww+t6gbIbgABg1zyzGiBygBizGCKeAO7ekBKhxkggLYQKw4WMEGIMB0JFiDBUCBfBxlAgUgQLM4JoEWRMD2KFIGFaEGvEEFODzEJ0MSVkNqKJySFeiComQbwRB8x6IiLHfCaiWQWsCstX9DgRsUVDmsZ+EmbLvybljfkhSkjMC/OHqEE8MAdECzITU0X0IDMwTcQIYonpIigQC8wQQYVoMCQEByLBkBFcCAfDQkggFAwbIYX0MCKEBlLDiBEx7X0kLVTxUCNGAMAbEaxAsi6eqe8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicatored.png
// module id = 8LlQ
// module chunks = 1